import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AppSettings } from 'src/app/app.settings';
import { CustomerService } from 'src/app/core/services/customer.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticateService } from 'src/app/core/services/authenticate.service';
import { AppData } from 'src/app/app.data';
import { Settings } from 'src/app/app.settings.model';
import { SelectListItem } from 'src/app/core/models/select-list-item';
import { Location } from '@angular/common';
import { QuestionService } from 'src/app/dynamic-forms/services/question.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl, AbstractControl } from '@angular/forms';
import { noWhitespaceValidator, identityValidator, phoneValidator, emailValidator, NotificationValidator, PreferredNotificationValidator } from 'src/app/validators/app-validators';
import moment from 'moment';
import { SchedulerService } from '../../scheduler/scheduler.service';
import { ApiResponseCode, customerFieldType } from 'src/app/core/enums';
import { CustomerModel } from 'src/app/core/models/customer-model';
import { MyErrorStateMatcher } from 'src/app/core/models/my-error-state-mathcher';
import { ErrorStateMatcher } from '@angular/material/core';
import { Utils } from 'src/app/core/utils';
import { ModulesService } from 'src/app/core/services/modules.service';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';

@Component({
  selector: 'app-new-customer',
  templateUrl: './new-customer.component.html',
  styleUrls: ['./new-customer.component.scss']
})
export class NewCustomerComponent implements OnInit, AfterViewInit {

  // Error when invalid control is dirty, touched or submitted.
  matcher: ErrorStateMatcher = new MyErrorStateMatcher();

  FIELD_TYPE_TEXT = 1;
  FIELD_TYPE_DATE = 2;
  FIELD_TYPE_DROPDOWN = 3;
  FIELD_TYPE_INTEGER = 4;
  FIELD_TYPE_CHECKBOX = 5;

  error: string;
  settings: Settings;
  businessID: number = 0;
  selectedIDTypeText: string = '';

  form: UntypedFormGroup;
  idTypes = [];
  genders = [];
  idMaxLength: number = 9;
  therapists: SelectListItem[] = [];
  cities: SelectListItem[] = [];

  // additional fields dropdown
  dropdown1: SelectListItem[] = [];
  dropdown2: SelectListItem[] = [];
  dropdown3: SelectListItem[] = [];

  // fileds
  fieldsMetadata: metadataField[] = [];
  additionalFields: metadataField[] = [];
  maxBirthDate = new Date();
  requiredFields: string[] = [];
  fieldsNotAvailableForMobile: string[] = ['PostalCode', 'TelHome', 'Tel2', 'MaritalStatus', 'NotificationByEmail'];

  isWhatsAppEnabled: boolean = false;

  // subscription
  private subIdType: any;
  private subSmsNotificationCheckbox: any;
  private subEmailNotificationCheckbox: any;
  private subDoNotNotifyCheckbox: any;

  constructor(private appSettings: AppSettings,
    public fb: UntypedFormBuilder,
    private customerService: CustomerService,
    private schedulerService: SchedulerService,
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private moduleService: ModulesService,
    private location: Location,
    private appData: AppData,

  ) {


    this.settings = appSettings.settings;
    this.businessID = appData.newCustomerBusinessID || 0;


  }

  ngOnInit() {
    // this.questions= this.questionService.getQuestions();

    this.loadIsWhatsAppEnabled();

    this.initIdTypes();
    this.initGenders();
    this.loadTherapistsInScope();
    this.loadCities();
    this.initForm();
    this.loadAdditionalFieldMetadata();
    this.onChange();
  }




  onChange() {

    // trigger validation of identity when changing from  id to passport
    this.subIdType = this.f.IDNumberType.valueChanges.subscribe(x => {
      this.f.IDNumber.updateValueAndValidity();
    });

    this.subSmsNotificationCheckbox = this.f.NotificationBySms.valueChanges.subscribe(x => {
      this.f.Mobile.markAsTouched();
      this.f.Mobile.updateValueAndValidity();
    });

    this.subEmailNotificationCheckbox = this.f.NotificationByEmail.valueChanges.subscribe(x => {
      this.f.Email.markAsTouched();
      this.f.Email.updateValueAndValidity();
    });

    this.subDoNotNotifyCheckbox = this.f.DoNotNotificate.valueChanges.subscribe(x => {
      this.f.Email.updateValueAndValidity();
      this.f.Mobile.updateValueAndValidity();
    });

  }

  unsubscribe() {
    if (this.subIdType) {
      this.subIdType.unsubscribe();
    }
    if (this.subSmsNotificationCheckbox) {
      this.subSmsNotificationCheckbox.unsubscribe();
    }
    if (this.subEmailNotificationCheckbox) {
      this.subEmailNotificationCheckbox.unsubscribe();
    }
    if (this.subDoNotNotifyCheckbox) {
      this.subDoNotNotifyCheckbox.unsubscribe();
    }
  }


  ngAfterViewInit() {
    this.settings.loadingSpinner = false;
  }

  initIdTypes() {
    this.idTypes = [
      { value: '1', text: this.translate.instant('COMMON.TZ') }, // this not work
      { value: '2', text: this.translate.instant('COMMON.Passport') }
    ];

    // Translate asynchronous
    this.translate.get('COMMON.TZ').subscribe(x => {
      this.idTypes[0].text = x;
    });

    this.translate.get('COMMON.Passport').subscribe(x => {
      this.idTypes[1].text = x;
    });

  }

  initGenders() {
    this.genders = [
      { value: '1', text: this.translate.instant('GENDER.MALE') },
      { value: '2', text: this.translate.instant('GENDER.FEMALE') }
    ];

    // Translate asynchronous
    this.translate.get('GENDER.MALE').subscribe(x => {
      this.genders[0].text = x;
    });

    this.translate.get('GENDER.FEMALE').subscribe(x => {
      this.genders[1].text = x;
    });

  }

  initForm() {

    this.form = this.fb.group({
      'BusinessID': [this.businessID],
      'FirstName': ['', [Validators.required, Validators.minLength(2), Validators.maxLength(20), noWhitespaceValidator]],
      'LastName': ['', [Validators.required, Validators.minLength(3), noWhitespaceValidator]],
      'IDNumberType': ['1', Validators.required],
      'IDNumber': [''],
      'Gender': [''],
      'BirthDate': [null],
      'Mobile': [null, phoneValidator],
      'Email': [null, emailValidator],
      'Address': [null],
      'CityID': [null],
      'TherapistID': [null],
      'NotificationBySms': [false],
      'NotificationByEmail': [false],
      'NotificationByWhatsApp': [false],
      'DoNotNotificate': [true],
      'PreferredNotifications': [null]
    }, {
      validator: [
        identityValidator('IDNumberType', 'IDNumber'),
        NotificationValidator('Mobile', 'NotificationBySms'),
        NotificationValidator('Email', 'NotificationByEmail'),
        NotificationValidator('Mobile', 'NotificationByWhatsApp'),
        //PreferredNotificationValidator('NotificationBySms','NotificationByEmail','DoNotNotificate')
      ]
    });

  }



  loadAdditionalFieldMetadata() {

    this.customerService.getCustomerMetadata(this.businessID).subscribe(result => {

      if (result.Data) {
        this.dropdown1 = result.Data.dropdown1;
        this.dropdown2 = result.Data.dropdown2;
        this.dropdown3 = result.Data.dropdown3;
        this.buildFormWithAdditionalFields(result.Data.fields);
      }
    });
  }


  buildFormWithAdditionalFields(fields) {

    this.fieldsMetadata = fields as metadataField[];
    this.additionalFields = this.fieldsMetadata.filter(x => x.isAdditional && x.active);

    // Add new controls for addiotinal fields
    for (let index = 0; index < this.additionalFields.length; index++) {
      const element = this.additionalFields[index];
      this.form.addControl(element.name, new UntypedFormControl('', element.required ? Validators.required : null));
    }
    debugger;

    // Update required validator for regular fields 
    var customerRequiredFields = this.fieldsMetadata.filter(x => !this.fieldsNotAvailableForMobile.includes(x.name) && x.required && !x.isAdditional);

    for (let index = 0; index < customerRequiredFields.length; index++) {
      const element = customerRequiredFields[index];
      let control: AbstractControl;

      // fix identity
      if (element.name === 'Identity') {
        element.name = 'IDNumber';
      }

      // for showing (*) sign for required fields
      this.requiredFields[element.name] = true;

      // the validators for firstName, lastName, and IDNumberType are set in the initForm
      if (element.name === 'FirstName' || element.name === 'LastName' || element.name === 'IDNumberType') {
        continue;
      }


      control = this.form.controls[element.name];
      if (control) {
        switch (element.name) {
          case 'Mobile':
            // this will reset any existing validators for the control set before
            control.setValidators([Validators.required, phoneValidator]);
            break;
          case 'Email':
            // this will reset any existing validators for the control set before
            control.setValidators([Validators.required, emailValidator]);
            break;
          default:
            // this will reset any existing validators for the control set before
            control.setValidators([Validators.required]);
            break;
        }
      }
    }

  }

  isRequired(controlName) {
    let control = this.form.controls[controlName];
    let errors = control.errors;
    return errors && errors.required || false;
  }

  loadTherapistsInScope() {
    this.schedulerService.loadTherapistsInScope().subscribe(result => {
      if (result.Data) {
        this.therapists = result.Data;
      }
    });
  }


  loadCities() {
    this.customerService.loadCities().subscribe(result => {
      if (result) {
        this.cities = result;
      }
    });
  }

  // convenience getter for easy access to form fields.
  // example: this.f.duration.setValue(this.minDuration)
  get f() { return this.form.controls; }

  // for debug only
  get diagnostic() { return JSON.stringify(this.form.value); }


  isValid(key: string) {
    return this.form.controls[key].valid;
  }



  onBack(event) {
    const backURL = this.appData.newCustomerBackUrl;
    this.router.navigate([backURL]);
  }

  onSave(event) {
    this.error = '';

    // convert form to model
    let model = new CustomerModel(this.form.value);


    // run through required fields to check if they're valid
    for (let reqField in this.requiredFields) {
      try {
        if (this.requiredFields[reqField]) {
          let reqFieldVal = model[reqField];
          if (reqField === 'PreferredNotifications') {
            const isSmsChecked = this.form.controls['NotificationBySms'].value;
            const isEmailChecked = this.form.controls['NotificationBySms'].value;
            const isWhatsAppChecked = this.form.controls['NotificationByWhatsApp'].value;
            const isDoNotNotifyChecked = this.form.controls['DoNotNotificate'].value;
            if (isSmsChecked || isEmailChecked || isWhatsAppChecked || isDoNotNotifyChecked) {
              // valid if at least one checkbox is selected
              this.form.controls[reqField].setErrors(null);
              this.form.controls[reqField].markAsTouched();
            }
            else {
              this.form.controls[reqField].setErrors({ 'required': true });
              this.form.controls[reqField].markAsTouched();
            }

          }
          else {
            if (!reqFieldVal || Utils.isStringBlank(reqFieldVal)) {
              this.form.controls[reqField].setErrors({ 'required': true });
              this.form.controls[reqField].markAsTouched();
            }
          }
        }
      } catch (err) {
        debugger;
      }
    }

    if (this.form.invalid) {
      return;
    }

    this.customerService.create(model).subscribe(result => {
      if (result.Code !== 1) {
        this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
        console.log(JSON.stringify(result));
      } else {
        // move to patient details
        const customerID = result.Data.ID;
        this.error = customerID;
        this.router.navigate(['/patient-details', customerID]);
      }
    });
  }

  onSubmit(value) {
    // see onSave...
  }

  onIDTypeChanged(event) {

    let target = event.source.selected._element.nativeElement;
    let value = event.value;
    this.selectedIDTypeText = target.innerText.trim();
  }

  getTypeText() {
    var val = this.f.IDNumberType.value;
    return this.idTypes.filter(x => x.value === val)[0].text;
  }

  notificationChanged(event, type) {

    // let checked = event.checked;
    let smsChecked = this.f.NotificationBySms.value;
    let emailChecked = this.f.NotificationBySms.value;
    let whatsappChecked = this.f.NotificationByWhatsApp.value;
    //let doNotNotifyChecked = this.f.DoNotNotificate.value;

    switch (type) {
      case 'SMS':
      case 'Email':
      case 'WhatsApp':
        this.f.DoNotNotificate.setValue(!(smsChecked || emailChecked || whatsappChecked));
        break;
      case 'None':
        this.f.NotificationBySms.setValue(false);
        this.f.NotificationByEmail.setValue(false);
        this.f.NotificationByWhatsApp.setValue(false);
        this.f.DoNotNotificate.setValue(true);
        break;
      default:
        break;
    }
  }

  loadIsWhatsAppEnabled(): void {
    this.moduleService.isWhatsAppEnabled().subscribe({
      next: result => {
        
        if (result?.Code !== ApiResponseCode.Success) {
          this.isWhatsAppEnabled = false;
          this.error = this.translate.instant(`ERROR.CODE.${result?.Code}`);
          return;
        }

        this.isWhatsAppEnabled = result.Data.IsWhatsAppEnabled;
      },
      error: err => {
        debugger;
        this.error = err;
      }
    });


  }
}



export interface metadataField {
  metadataName: string;
  name: string;
  active: boolean;
  alias: string;
  required: boolean;
  resourceKey: string;
  isAdditional: boolean;
  fieldType: customerFieldType;
}

